<template>
    <div
        v-if="isOpen"
        class="ppv2-fixed ppv2-inset-0 ppv2-flex ppv2-items-center ppv2-justify-center !ppv2-bg-black !ppv2-bg-opacity-70 ppv2-z-[9999]"
        @click.self="onCancel"
    >
        <div
            class="ppv2-relative ppv2-bg-[#F8F9FB] ppv2-rounded-3xl ppv2-w-[90%] ppv2-max-w-[1000px] ppv2-flex ppv2-flex-col ppv2-overflow-hidden"
            style="height: 85vh"
        >
            <!-- Close Button -->
            <button
                @click="onCancel"
                class="ppv2-absolute ppv2-right-4 ppv2-top-4 ppv2-w-10 ppv2-h-10 ppv2-bg-gray-200 ppv2-rounded-full ppv2-flex ppv2-items-center ppv2-justify-center hover:ppv2-bg-gray-300 ppv2-transition-colors ppv2-z-10"
            >
                <X :size="20" class="ppv2-text-gray-600" />
            </button>

            <!-- PDF Container -->
            <div class="ppv2-flex-1 ppv2-overflow-hidden ppv2-p-6 ppv2-pb-4 ppv2-mt-10">
                <div class="ppv2-w-full ppv2-h-full ppv2-bg-white ppv2-shadow-sm ppv2-rounded-xl ppv2-overflow-hidden">
                    <iframe
                        v-if="invoiceUrl"
                        :src="invoiceUrl"
                        class="ppv2-w-full ppv2-h-full ppv2-border-0"
                        :title="$t('invoices.preview_title')"
                    ></iframe>
                    <div v-else class="ppv2-w-full ppv2-h-full ppv2-flex ppv2-items-center ppv2-justify-center">
                        <div
                            class="ppv2-animate-spin ppv2-rounded-full ppv2-h-12 ppv2-w-12 ppv2-border-b-4 ppv2-border-purple-600"
                        ></div>
                    </div>
                </div>
            </div>

            <!-- Actions -->
            <div class="ppv2-px-8 ppv2-pb-6 ppv2-pt-2 ppv2-flex ppv2-justify-center" :style="{ gap: normalizeSize(16, true) }">
                <button
                    @click="onDownload"
                    class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-2 ppv2-bg-[#8134AF] hover:ppv2-bg-[#6a2992] ppv2-text-white ppv2-px-8 ppv2-py-3 ppv2-rounded-xl ppv2-transition-colors poppinsMedium ppv2-w-64"
                >
                    <Download :size="18" />
                    <span>{{ $t('invoices.download') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'

import { X, Download } from 'lucide-vue'

export default {
    name: 'InvoicePreviewModal',
    components: {
        X,
        Download,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        invoice: {
            type: Object,
            default: null,
        },
    },
    computed: {
        invoiceUrl() {
            if (!this.invoice || !this.invoice.id || !this.invoice.order_id) return null
            return `/back-office/invoice/${this.invoice.order_id}/${this.invoice.id}#toolbar=0&navpanes=0&scrollbar=0`
        },
    },
    methods: {
        normalizeSize,
        onCancel() {
            this.$emit('close')
        },
        async onDownload() {
            if (this.invoice && this.invoice.id && this.invoice.order_id) {
                try {
                    const url = `/back-office/invoice/${this.invoice.order_id}/${this.invoice.id}`
                    const response = await fetch(url)
                    const blob = await response.blob()
                    const blobUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = blobUrl
                    link.download = `${this.$t('invoices.invoice')}_${this.invoice.fiscal_number || this.invoice.id}.pdf`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(blobUrl)
                } catch (error) {
                    const message = error.response?.data?.message || this.$t('invoices.errors.generic')
                    this.$toast.error(message)
                }
            }
        },
        handleKeydown(e) {
            if (e.key === 'Escape' && this.isOpen) {
                this.onCancel()
            }
        },
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                document.body.style.overflow = 'hidden'
                document.addEventListener('keydown', this.handleKeydown)
            } else {
                document.body.style.overflow = ''
                document.removeEventListener('keydown', this.handleKeydown)
            }
        },
    },
    beforeDestroy() {
        document.body.style.overflow = ''
        document.removeEventListener('keydown', this.handleKeydown)
    },
}
</script>
